import qs from "qs";
import apiClient from './apiClient';


const fetchRegions = async (keyword: string) => {
	const query = qs.stringify({ keyword }, { skipNulls: true });
	const response = await apiClient.get(`/api/geo/search/kakao?${query}`);
	return response.data;
}

const geoAPI = {
	fetchRegions,
};

export default geoAPI;
